// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__m16MK","tab":"Tabs_tab__Iv4ik","tabActive":"Tabs_tabActive__30aTf"};